<!-- New Changes related to sector clone start -->
<div class="panel panel-default">
    <div class="panel-heading">
        <ul class="nav nav-tabs">
            <li [class.active]="tabSectorSelected === 'newsectors'" (click)="onSectorSelector('newsectors')">
                <a data-toggle="tab"><b style="font-size:18px;">New Sectors</b></a>
            </li>
            <li [class.active]="tabSectorSelected === 'clonesectors'" (click)="onSectorSelector('clonesectors')">
                <a data-toggle="tab"><b style="font-size:18px;">Clone Sectors</b></a>
            </li>
        </ul>
    </div>
</div>
<!-- New Changes related to sector clone End -->

<div class="panel-body" style="height:auto!important;">
    <div class="tab-content" style="padding-left:15px;">
        <div *ngIf="tabSectorSelected === 'newsectors'">
            <div id="sectors" class="tab-pane fade active in">
                <div style="width:32%;float:left;">
                    <h3 class="heading4">Add New Sector</h3>
                    <form #myForm="ngForm" (submit)="SectorCreate();myForm.reset()">
                        <!-- <input name="__RequestVerificationToken" type="hidden" 
                              value="yb1-v0YYqXJPjx51W19PUW3qZF3OJnhalHA8sQgJ6B_JVUfyIHTRwMPMq3jL9WGuf7cIkSLvuUlOg1iqrMsStW5pXDZLexRkXd9U4v-FxQs1">
                               -->
                        <div class="form-horizontal">
                            <div class="form-group">
                                <div class="col-md-10">
                                    <input class="pagefield text-box single-line" id="Sector_SectorName"
                                        [(ngModel)]="Sector_SectorName" name="SectorName"
                                        placeholder="Enter Sector Name here"
                                        style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;"
                                        type="text" value="">
                                    <!-- <span class="field-validation-valid text-danger" data-valmsg-for="Sector.SectorName" data-valmsg-replace="true"></span> -->
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-10">
                                    <input class="pagefield text-box single-line" id="Sector_Description"
                                        [(ngModel)]="Sector_Description" name="Desc"
                                        placeholder="Enter Sector Description"
                                        style="padding:30px 15px;width:75%;background-color:#F9f9f9 !important;border:none;"
                                        type="text" value="">
                                    <!-- <span class="field-validation-valid text-danger" data-valmsg-for="Sector.Description" data-valmsg-replace="true"></span> -->
                                </div>
                            </div>
                            <br>
                            <div class="form-group">
                                <div class="col-md-10">
                                    <input type="submit" value="Add Sector" class="btn btn-lg btn-primary buttonStyle">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div *ngIf="tabSectorSelected === 'clonesectors'">
            <div style="width:32%;float:left;">
                <h3>Add Clone Sector</h3>
                <form #myForm="ngForm" (submit)="cloneSectorCreate();myForm.reset()">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <div class="col-md-10">
                                <input class="pagefield text-box single-line" id="Sector_NewSectorName" type="text"
                                    [(ngModel)]="CloneSector_SectorName" name="NewSectorName"
                                    placeholder="Enter New Sector Name here"
                                    style="padding:15px;width:75%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;"
                                    value="">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-10">
                                <input class="pagefield text-box single-line" id="Sector_NewDescription" type="text"
                                    [(ngModel)]="CloneSector_Description" name="Desc"
                                    placeholder="Enter New Sector Description"
                                    style="padding:30px 15px;width:75%;background-color:#F9f9f9 !important;border:none;"
                                    type="text" value="">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-10">
                                <select class="pagefield list-box tri-state" id="Sector_CloneSectorId"
                                    name="CloneSectorId" [(ngModel)]="CloneSector_SectorId" style="width:100%;">
                                    <option value="null" disabled selected>Select Sector</option>
                                    <option *ngFor="let sector of sectorlist" [value]="sector.Id">
                                        {{sector.SectorName}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <br>
                        <div class="form-group">
                            <div class="col-md-10">
                                <input type="submit" value="Add Clone Sector"
                                    class="btn btn-lg btn-primary buttonStyle">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div style="width:56%;float:right;border-left: #eee solid 2px; min-height:600px;padding-left:30px;">
            <br> <br>
            <table class="table table-bordered table-hover">
                <thead>
                </thead>
                <colgroup>
                    <col width="25%">
                    <col width="50%">
                    <col width="25%">
                </colgroup>
                <tbody>
                    <tr style="background-color:#F9f9f9;">
                        <th>
                            <div class="center"><b>Sector Name</b></div>
                        </th>
                        <th>
                            <b>
                                <div class="center">Sector Description</div>
                            </b>
                        </th>
                        <th>
                            <div class="center"><b>Manage</b></div>
                        </th>
                    </tr>
                </tbody>
                <tbody style="text-align:center;">
                    <tr *ngFor="let sec of sectorlist">
                        <td>
                            {{sec.SectorName}}
                        </td>

                        <td>
                            {{sec.Description}}
                        </td>
                        <td>
                            <!-- <a class="modal-link"><span class="glyphicon glyphicon-pencil" style="color:#666;"></span></a>&nbsp;&nbsp; -->
                            <a (click)="showConfirm(sec)" class="modal-link"><span class="glyphicon glyphicon-trash"
                                    style="color:#666;"></span></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>